export enum UserRoleType {
  EDUCATION_MANAGER = 0,
  CENTRAL_MANAGER = 1,
  BRANCH_MANAGER = 2,
  USER = 3,
  INSTRUCTOR = 4,
  INTERN = 5,
  EDUCATION_SUPERVISOR = 6,
  INTERN_SUPERVISOR = 7,
}

export interface Role {
  id: string;
  roleName: string;
  roleDescription: string;
  type?: number;
  isDefault?: boolean;
  permissionKeys?: string;
  assignedPersonCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface RoleFilters {
  search?: string;
  roleName?: string;
  roleType?: number;
  /** API: sortBy - createdAt | name */
  sortBy?: "createdAt" | "name";
  /** API: sortOrder - asc | desc */
  sortOrder?: "asc" | "desc";
}

/** Domainde kullanılan bir ünvan ve o ünvandaki personel sayısı. */
export interface UserTitle {
  /** `User.title` — İK'dan geldiği hâliyle; atama isteğinde birebir gönderilir. */
  title: string;
  userCount: number;
  /** Rol filtresiyle sorgulandıysa: bu ünvandaki kaç kişide rol zaten tanımlı. */
  assignedCount?: number;
}

/** Ünvana göre toplu rol tanımlama sonucu. */
export interface AssignRoleByTitleResult {
  matchedUsers: number;
  assigned: number;
  alreadyAssigned: number;
  /** Hiç personeli bulunamayan ünvanlar — ekran uyarı olarak gösterir. */
  unmatchedTitles: string[];
}
